import "./earlybird.scss";

export default function EarlyThankYou() {
  return (
    <main className="early-thanks">
      <h2>Thank You for Securing an Early Bird Ticket</h2>
      <h4>Our team will be in touch with you shortly with the next steps.</h4>
    </main>
  );
}
